import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { useLocalizeMessage, Table, LocaleContext, formatStudyString } from 'libs.nucleus';
import { stepResponseTypes } from '../../constants/step_response_type.constants';
import { applyVariablesToStepResponse } from '../../helpers/step_response_variable.helpers';
import { StepResponseValue } from '../visit_activity_responses/step_response_value.component';
import { getStepQuestion } from '../visit_activity_responses/visit_activity_responses.utils';
export const ResponseDetailView = ({ response }) => {
    const translate = useLocalizeMessage();
    const currentLocale = useContext(LocaleContext);
    // Filter out completion step responses and disabled steps
    const validStepResponses = (response?.c_step_responses?.data || [])
        .filter((stepResponse) => {
        return stepResponse.type !== stepResponseTypes.cCompletion.objectType && !stepResponse.c_step.c_disabled;
    })
        .sort((x, y) => x.c_step.c_order - y.c_step.c_order);
    // Prepare table data
    const tableData = validStepResponses.map((stepResponse) => {
        const metaVariables = response?.c_metadata || {};
        const processedStepResponse = applyVariablesToStepResponse(stepResponse, metaVariables.variables);
        return {
            id: stepResponse._id,
            question: formatStudyString(getStepQuestion(processedStepResponse.c_step), currentLocale),
            response: _jsx(StepResponseValue, { stepResponse: processedStepResponse, variables: metaVariables.variables }),
        };
    });
    const columns = [
        {
            header: translate('generic.question'),
            accessorKey: 'question',
            cell: (context) => (_jsx("div", { className: 'text-sm text-gray-500', dangerouslySetInnerHTML: { __html: context.getValue() } })),
        },
        {
            header: translate('generic.responses', { count: 1 }),
            accessorKey: 'response',
            cell: (context) => {
                const value = context.getValue();
                return _jsx("div", { className: 'text-sm text-gray-900', children: React.isValidElement(value) ? value : String(value || '') });
            },
        },
    ];
    return (_jsxs("div", { className: 'flex flex-col gap-6', children: [_jsx("h3", { className: 'text-lg font-medium text-gray-900 mb-4', children: translate('generic.responses', { count: validStepResponses.length }) }), validStepResponses.length === 0 ? (_jsx("div", { className: 'text-center py-8 text-gray-500', children: _jsx("p", { children: translate('info.participant_responses.empty') }) })) : (_jsx(Table, { data: tableData, columns: columns, isLoading: false, labelNoResults: translate('info.participant_responses.filter_empty'), hasPagination: false }))] }));
};
